import "./PayrollScheduleDataGrid.css";

import React, { useRef, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

export interface IDataTable {
	rows: any;
	columns: any;
}

export const PayrollScheduleDataGrid: React.FC<IDataTable> = ({
	rows,
	columns,
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);

	return (
		<>
			<DataTable
				value={
					rows &&
					rows
				}
				emptyMessage={
					rows && rows.length === 0 ? "No Record Found." : "Loading..."
				}
				className="PayrollScheduleDataGrid"
				style={{ marginBottom: "2rem" }}
			>
				{columns && rows && rows.length > 0 && (
					<Column
						body={(rowData: any, row: any) => <span>{row.rowIndex + 1}</span>}
						header="#"
						style={{ width: "60px", textAlign: "center" }}
						frozen
						alignFrozen="left"
						resizeable={false}
						reorderable={false}
						sortable={false}
						className="indexColumn"
						headerClassName="indexColumn"
					/>
				)}

				{columns &&
					columns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									align={x.align}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
										maxWidth: x.maxWidth,
									}}
									headerStyle={{
										whiteSpace: "nowrap",
									}}
								/>
							);
						})}
			</DataTable>
		</>
	);
};
